import * as React from "react";
import { Helmet } from "react-helmet";
import CallToAction from "../templates/callToAction";
import FooterSection from "../templates/footer";
import NavBar from "../templates/navbar";
import HeroImage from "./../images/customersPage/hero.png";
import HeroBg from "./../images/customersPage/world-map.svg";
import HerosectionSecondary from "./../templates/heroSecondarySection";
import BlogsPreview from "./../templates/blogsPreview";

import caseStudyService from "./../modules/caseStudyService";

let caseStudyInfo = caseStudyService.caseStudyList;
let caseStudyNames = Object.keys(caseStudyInfo);
let caseStudyList = [];
for (let i = 0; i < caseStudyNames.length; i++) {
  console.log(caseStudyNames[i], caseStudyInfo);
  caseStudyList.push(caseStudyInfo[caseStudyNames[i]]);
}

// markup
const IndexPage = () => {
  return (
    <main>
      <Helmet>
        <meta charset="utf-8" />
        <meta name="description" content="Growlytics Success Stories" />
        <meta name="google" content="nositelinkssearchbox" />
        <title>Growlytics Success Stories</title>
        <link rel="canonical" href="/" />
      </Helmet>
      <NavBar></NavBar>

      {/* Hero Section */}
      <HerosectionSecondary background={HeroBg} image={HeroImage} title1="10,000+ ecommerce brands trust Growlytics" description="The most advanced companies in the world use Growlytics" lightBackground={false}></HerosectionSecondary>

      {/* Case Study List */}
      <div className="lg:mx-auto lg:max-w-7xl lg:px-8">
        <div className="bg-white py-12">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="lg:text-center">
              <p className="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">Customer stories that motivate our work</p>
              <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">Checkout our customer stories, see why more than 1,000 brands use Growlytics to improve conversion, LTV and retention.</p>
            </div>
          </div>
        </div>

        {caseStudyList.map((caseStudy) => (
          <div>
            {/* Mobile */}
            <div key={caseStudy.company} className="mx-4 my-10 rounded-xl overflow-hidden shadow md:hidden" style={{ background: caseStudy.teasor.background }}>
              <img class="w-full" src={caseStudy.image} />

              <div className="px-6 pt-6">
                <div className="mx-auto text-xl leading-8 text-black">
                  <img style={{ height: "40px" }} src={caseStudy.logo} />
                  <div className="mt-2">&ldquo;{caseStudy.teasor.description}&rdquo;</div>
                </div>

                <a href={"/case-study/" + caseStudy.id} className="cursor-pointer my-6 rounded-full inline-flex items-center text-center bg-primary-600 px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2">
                  Read Full Case Study &nbsp;&nbsp;
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Desktop View */}
            <div key={caseStudy.company} className="my-10 rounded-xl overflow-hidden shadow hidden md:block" style={{ background: caseStudy.teasor.background }}>
              <div className="flex flex-row overflow-hidden" style={{ borderRadius: "10px 0px 0px 0px" }}>
                <div className="flex-none">
                  <img style={{ width: "530px" }} src={caseStudy.image} />
                </div>

                {/* Right Side */}
                <div className="px-6 pt-6">
                  <div className="mx-auto text-2xl leading-8 text-black">
                    <img style={{ height: "60px" }} src={caseStudy.logo} />
                    <div className="mt-2">&ldquo;{caseStudy.teasor.description}&rdquo;</div>
                  </div>

                  <a href={"/case-study/" + caseStudy.id} className="cursor-pointer mt-6 rounded-full inline-flex items-center text-center bg-primary-600 px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2">
                    Read Full Case Study &nbsp;&nbsp;
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Call To Action */}
      <CallToAction></CallToAction>

      {/* Blogs Preview */}
      <BlogsPreview></BlogsPreview>

      {/* Add Footer */}
      <FooterSection></FooterSection>
    </main>
  );
};

export default IndexPage;
